import { useEffect } from 'react';
import './NewsletterModal.css';

export function NewsletterModal({ isOpen, onClose }) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="newsletter-modal-overlay" onClick={onClose}>
      <div className="newsletter-modal" onClick={(e) => e.stopPropagation()}>
        <button className="newsletter-modal__close" onClick={onClose} aria-label="Close">
          &times;
        </button>

        <div className="newsletter-modal__content">
          <h2>Subscribe to the PRINCIPLES Newsletter</h2>
          <p className="newsletter-modal__intro">
            Principle-Based news and insights on human &amp; organizational performance, leadership, and safety culture delivered to your inbox.
          </p>

          <form
            action="https://ppiweb.us7.list-manage.com/subscribe/post?u=3a268b76b2780db9407724187&amp;id=7f68753ef8&amp;f_id=0049a8e4f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="newsletter-modal__form"
            target="_blank"
          >
            <div className="newsletter-modal__field">
              <label htmlFor="mce-EMAIL">
                Email Address <span className="required">*</span>
              </label>
              <input
                type="email"
                name="EMAIL"
                id="mce-EMAIL"
                required
                placeholder="you@example.com"
              />
            </div>

            <div className="newsletter-modal__row">
              <div className="newsletter-modal__field">
                <label htmlFor="mce-FNAME">First Name</label>
                <input type="text" name="FNAME" id="mce-FNAME" placeholder="First name" />
              </div>

              <div className="newsletter-modal__field">
                <label htmlFor="mce-LNAME">Last Name</label>
                <input type="text" name="LNAME" id="mce-LNAME" placeholder="Last name" />
              </div>
            </div>

            <div className="newsletter-modal__field">
              <label htmlFor="mce-MMERGE3">Company</label>
              <input type="text" name="MMERGE3" id="mce-MMERGE3" placeholder="Company name" />
            </div>

            <div className="newsletter-modal__checkbox">
              <input type="checkbox" id="gdpr_47655" name="gdpr[47655]" value="Y" />
              <label htmlFor="gdpr_47655">
                I agree to receive email communications from PPI Global
              </label>
            </div>

            <p className="newsletter-modal__privacy">
              By clicking subscribe, you agree to our{' '}
              <a href="https://ppiweb.io/terms_and_conditions" target="_blank" rel="noopener noreferrer">
                Terms & Conditions
              </a>.
            </p>

            {/* Honeypot field */}
            <div aria-hidden="true" style={{ position: 'absolute', left: '-5000px' }}>
              <input
                type="text"
                name="b_3a268b76b2780db9407724187_7f68753ef8"
                tabIndex="-1"
                defaultValue=""
              />
            </div>

            <button type="submit" className="btn btn-primary newsletter-modal__submit">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
